namespace $.$$ {

	$mol_style_define( $shm_projects_task, {
		Details_page: {
			flex: { basis: '30rem', grow: 0, shrink: 0 },
			width: '30rem',
			minWidth: '30rem',
			Head: {
				height: '4rem',
				minHeight: '4rem',
				alignItems: 'center',
				flexWrap: 'nowrap',
			},
			Title: {
				minWidth: 0,
				minHeight: 0,
				alignItems: 'center',
				flexWrap: 'nowrap',
				gap: 0,
				padding: 0,
				overflow: 'hidden',
			},
		},
		Task_title: {
			minWidth: 0,
			width: 0,
			padding: '0.5rem',
			flex: { grow: 1, shrink: 1, basis: 0 },
		},
		Description_card: {
			flex: { direction: 'column' },
			gap: $mol_gap.block,
			padding: $mol_gap.block,
			background: { color: $mol_theme.card },
			border: { radius: $mol_gap.round },
			minWidth: 0,
		},
		Description_title: {
			font: { weight: 'bold' },
		},
		Result_card: {
			flex: { direction: 'column', shrink: 0 },
			gap: $mol_gap.block,
			padding: $mol_gap.block,
			background: { color: $mol_theme.card },
			border: { radius: $mol_gap.round },
			minWidth: 0,
		},
		Result_title: {
			font: { weight: 'bold' },
		},
	} )

}
